import { Box, Flex, Table, TableContainer, Text, Tfoot, Thead, Tr } from '@chakra-ui/react'
import { user } from '../../../helpers/user'
import * as S from '../../../global/GlobalStyles'
import React, { useMemo } from 'react'
import { ListLayout } from './ListLayout'
import { ModalCancel } from './components/ModalCancel'

const codUsu = user.codigo_usuario

const isAdmin = ['14', '30'].some((str) => codUsu?.toString().includes(str))

export function TableScreen({ data }) {
  const [selectedLayouts, setSelectedLayouts] = React.useState([])

  const listOrderby = useMemo(
    () =>
      data?.sort((a, b) => {
        if (a.prioridade === true && b.prioridade !== true) {
          return -1 // O item "a" tem prioridade, deve vir primeiro
        }

        if (b.prioridade === true && a.prioridade !== true) {
          return 1 // O item "b" tem prioridade, deve vir primeiro
        }

        if (a.tipo_pedido === 'Pedido' && b.tipo_pedido !== 'Pedido') {
          return -1 // O item "a" é um Pedido, deve vir primeiro
        }

        if (b.tipo_pedido === 'Pedido' && a.tipo_pedido !== 'Pedido') {
          return 1 // O item "b" é um Pedido, deve vir primeiro
        }

        return parseInt(a.prazo_entrega) - parseInt(b.prazo_entrega)
      }),
    [data]
  )

  function handleSelectLayout(item) {
    setSelectedLayouts((prevState) => {
      const index = prevState.findIndex((layout) => layout.id === item.id)

      if (index === -1) {
        return [...prevState, item]
      }

      return prevState.filter((layout) => layout.id !== item.id)
    })
  }

  return (
    <Box w="full">
      <Flex alignItems="center" justifyContent="space-between">
        <Text fontSize="0.9rem" fontWeight="bold" color={'gray.600'} textAlign="end" paddingRight={'1rem'} paddingBottom={'1rem'}>
          Contador: {data?.length}
        </Text>
        <ModalCancel selectedLayouts={selectedLayouts} setSelectedLayouts={setSelectedLayouts} />
      </Flex>
      <TableContainer textAlign="center" overflowY="auto" overflow="auto" maxH="calc(100vh - 200px)">
        <Table variant="simple" colorScheme="gray" fontSize="0.7rem" size={'sm'} borderCollapse="collapse">
          <Thead textAlign="center" px="6rem" position="sticky" top="0" zIndex="1">
            <Tr bg="#378BBF" color="white" mx="6rem">
              <S.Th>DT SOLICITA</S.Th>
              <S.Th>TIPO</S.Th>
              <S.Th>NRO</S.Th>
              <S.Th>Referência</S.Th>
              <S.Th>Vendedor</S.Th>
              <S.Th>PRODUTO</S.Th>
              <S.Th>COR</S.Th>
              <S.Th>GRAVAÇÃO</S.Th>
              <S.Th>PRAZO</S.Th>
              <S.Th>LOGO</S.Th>
              <S.Th>OBS</S.Th>
              <S.Th>Base Layout</S.Th>
              <S.Th>Link layout</S.Th>
              <S.Th>Qtd. Batidas</S.Th>
              {isAdmin && <S.Th></S.Th>}
              <S.Th>Upload Layout</S.Th>
              <S.Th>Cancelar</S.Th>
              <S.Th>Data Finalização</S.Th>
            </Tr>
          </Thead>

          <ListLayout list={listOrderby} selectedLayouts={selectedLayouts} handleSelectLayout={handleSelectLayout} />
        </Table>
      </TableContainer>
    </Box>
  )
}
